import {
  PROPOSAL_PRODUCTS_REQUEST, PROPOSAL_PRODUCTS_SUCCESS, PROPOSAL_PRODUCTS_FAILURE,
  PROPOSAL_PRODUCTS_ALL_REQUEST, PROPOSAL_PRODUCTS_ALL_SUCCESS, PROPOSAL_PRODUCTS_ALL_FAILURE,
  PROPOSAL_PRODUCT_ADD_REQUEST, PROPOSAL_PRODUCT_ADD_SUCCESS, PROPOSAL_PRODUCT_ADD_FAILURE,
  PROPOSAL_PRODUCT_UPDATE_REQUEST, PROPOSAL_PRODUCT_UPDATE_SUCCESS, PROPOSAL_PRODUCT_UPDATE_FAILURE,
  PROPOSAL_PRODUCT_DELETE_REQUEST, PROPOSAL_PRODUCT_DELETE_SUCCESS, PROPOSAL_PRODUCT_DELETE_FAILURE,
  PROPOSAL_SETTINGS_REQUEST, PROPOSAL_SETTINGS_SUCCESS, PROPOSAL_SETTINGS_FAILURE,
  PROPOSAL_SETTINGS_UPDATE_REQUEST, PROPOSAL_SETTINGS_UPDATE_SUCCESS, PROPOSAL_SETTINGS_UPDATE_FAILURE,
  PROPOSAL_SEED_REQUEST, PROPOSAL_SEED_SUCCESS, PROPOSAL_SEED_FAILURE,
  PROPOSAL_CATALOG_RESET
} from '../actions/proposalCatalog'

const INITIAL_STATE = {
  products: null,
  settings: null,
  needsRefresh: false,
  error: null,
  loading: false
}

const proposalCatalogReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    // Fetch active products
    case PROPOSAL_PRODUCTS_REQUEST:
      return { ...state, error: null, loading: true }
    case PROPOSAL_PRODUCTS_SUCCESS:
      return { ...state, products: action.response, needsRefresh: false, error: null, loading: false }
    case PROPOSAL_PRODUCTS_FAILURE:
      return { ...state, error: action.error, loading: false }

    // Fetch all products (admin)
    case PROPOSAL_PRODUCTS_ALL_REQUEST:
      return { ...state, error: null, loading: true }
    case PROPOSAL_PRODUCTS_ALL_SUCCESS:
      return { ...state, products: action.response, needsRefresh: false, error: null, loading: false }
    case PROPOSAL_PRODUCTS_ALL_FAILURE:
      return { ...state, error: action.error, loading: false }

    // Add product
    case PROPOSAL_PRODUCT_ADD_REQUEST:
      return { ...state, error: null, loading: true }
    case PROPOSAL_PRODUCT_ADD_SUCCESS:
      return { ...state, needsRefresh: true, error: null, loading: false }
    case PROPOSAL_PRODUCT_ADD_FAILURE:
      return { ...state, error: action.error, loading: false }

    // Update product
    case PROPOSAL_PRODUCT_UPDATE_REQUEST:
      return { ...state, error: null, loading: true }
    case PROPOSAL_PRODUCT_UPDATE_SUCCESS:
      return { ...state, needsRefresh: true, error: null, loading: false }
    case PROPOSAL_PRODUCT_UPDATE_FAILURE:
      return { ...state, error: action.error, loading: false }

    // Delete product
    case PROPOSAL_PRODUCT_DELETE_REQUEST:
      return { ...state, error: null, loading: true }
    case PROPOSAL_PRODUCT_DELETE_SUCCESS:
      return { ...state, needsRefresh: true, error: null, loading: false }
    case PROPOSAL_PRODUCT_DELETE_FAILURE:
      return { ...state, error: action.error, loading: false }

    // Fetch settings
    case PROPOSAL_SETTINGS_REQUEST:
      return { ...state, error: null, loading: true }
    case PROPOSAL_SETTINGS_SUCCESS:
      return { ...state, settings: action.response, error: null, loading: false }
    case PROPOSAL_SETTINGS_FAILURE:
      return { ...state, error: action.error, loading: false }

    // Update settings
    case PROPOSAL_SETTINGS_UPDATE_REQUEST:
      return { ...state, error: null, loading: true }
    case PROPOSAL_SETTINGS_UPDATE_SUCCESS:
      return { ...state, settings: action.response, error: null, loading: false }
    case PROPOSAL_SETTINGS_UPDATE_FAILURE:
      return { ...state, error: action.error, loading: false }

    // Seed
    case PROPOSAL_SEED_REQUEST:
      return { ...state, error: null, loading: true }
    case PROPOSAL_SEED_SUCCESS:
      return { ...state, needsRefresh: true, error: null, loading: false }
    case PROPOSAL_SEED_FAILURE:
      return { ...state, error: action.error, loading: false }

    case PROPOSAL_CATALOG_RESET:
      return { ...state, error: null, loading: false }

    default:
      return state
  }
}

export default proposalCatalogReducer
